<template>

    <BaseLayout>
        <n-form ref="formRef" :model="form" :rules="rules" label-placement="top" class="application-form">

            <section class="application-card first-card">
            <h2 class="section-title">{{ $t('personalInformation') }}</h2>
            <p class="section-subtitle">{{ $t('personalInformationDescription') }}</p>



            <div class="grid grid-cols-6 gap-4">
                <div class="col-span-6 sm:col-span-3">
                    <n-form-item :label="$t('areYouAStudent')">
                        <n-radio-group v-model:value="form.isStudent" name="isStudent">
                            <n-radio :value="1">{{ $t('yes') }}</n-radio>
                            <n-radio :value="0">{{ $t('no') }}</n-radio>
                        </n-radio-group>
                    </n-form-item>
                </div>
                <div class="col-span-6 sm:col-span-3">

                    <n-form-item :label="$t('title')"  path="title">
                        <n-select
                            v-model:value="form.title"
                            :options="titleOptions"
                            :placeholder="$t('SelectPlaceHolder')"
                        />
                    </n-form-item>
                </div>
                <div class="col-span-6 sm:col-span-2">

                    <n-form-item  :label="$t('firstName')"   path="firstName">
                        <n-input v-model:value="form.firstName"    :placeholder="$t('PleaseInput')"/>
                    </n-form-item>
                </div>
                <div class="col-span-6 sm:col-span-2">
                    <n-form-item :label="$t('lastName')"    path="lastName">
                        <n-input v-model:value="form.lastName" :placeholder="$t('PleaseInput')"/>
                    </n-form-item>
                </div>

                <div class="col-span-6 sm:col-span-2">
                    <n-form-item :label="$t('street')"  path="street">
                        <n-input v-model:value="form.street" :placeholder="$t('PleaseInput')" />
                    </n-form-item>
                </div>
                <div class="col-span-6 sm:col-span-1">
                    <n-form-item :label="$t('houseNumber')"   path="houseNumber">
                        <n-input v-model:value="form.houseNumber" :placeholder="$t('PleaseInput')" />
                    </n-form-item>
                </div>
                <div class="col-span-6 sm:col-span-1">
                    <n-form-item :label="$t('postalCode')"  path="postalCode">
                        <n-input v-model:value="form.postalCode" :placeholder="$t('PleaseInput')" />
                    </n-form-item>
                </div>
                <div class="col-span-6 sm:col-span-2">
                    <n-form-item :label="$t('city')"   path="city">
                        <n-input v-model:value="form.city" :placeholder="$t('PleaseInput')"/>
                    </n-form-item>
                </div>

                <div class="col-span-6 sm:col-span-2">
                    <n-form-item :label="$t('phoneNumber')"  path="phone">
                        <n-input v-model:value="form.phone" :placeholder="$t('PleaseInput')"/>
                    </n-form-item>
                </div>
                <div class="col-span-6 sm:col-span-2">
                    <n-form-item :label="$t('email')"   path="email">
                        <n-input v-model:value="form.email" :placeholder="$t('PleaseInput')"/>
                    </n-form-item>
                </div>

                <div class="col-span-6 sm:col-span-2" v-if="!form.isStudent">
                    <n-form-item :label="$t('dateOfBirth')"   path="birthDate">
                        <n-date-picker
                            v-model:formatted-value="form.birthDate"
                            value-format="yyyy-MM-dd"
                            :format="'dd.MM.yyyy'"
                            :placeholder="$t('SelectDate')"
                            type="date"
                            style="width: 100%"
                            clearable
                        />
                    </n-form-item>
                </div>
                <div class="col-span-6 sm:col-span-2" v-if="!form.isStudent">
                    <n-form-item :label="$t('placeOfBirth')"   path="placeOfBirth">
                        <n-input v-model:value="form.placeOfBirth" :placeholder="$t('PleaseInput')"/>
                    </n-form-item>
                </div>

                <!--                  <div class="col-span-6 sm:col-span-2">-->
                <!--                    <n-form-item :label="$t('maritalStatus')"    path="maritalStatus">-->
                <!--                        <n-input v-model:value="form.maritalStatus" :placeholder="$t('PleaseInput')" />-->
                <!--                    </n-form-item>-->
                <!--                  </div>-->
                <div class="col-span-6 sm:col-span-2" v-if="!form.isStudent">
                    <n-form-item :label="$t('nationality')"   path="nationality">
                        <n-input v-model:value="form.nationality" :placeholder="$t('PleaseInput')"/>
                    </n-form-item>
                </div>
                <div class="col-span-6 sm:col-span-2" v-if="!form.isStudent">
                    <n-form-item :label="$t('denomination')"    path="denomination">
                        <n-input v-model:value="form.denomination" :placeholder="$t('PleaseInput')"/>
                    </n-form-item>
                </div>

                <!--                  <div class="col-span-6 sm:col-span-2">-->
                <!--                    <n-form-item :label="$t('fathersFirstName')"  path="fatherFirstName">-->
                <!--                        <n-input v-model:value="form.fatherFirstName" :placeholder="$t('PleaseInput')"/>-->
                <!--                    </n-form-item>-->
                <!--                  </div>-->
                <!--                  <div class="col-span-6 sm:col-span-2">-->
                <!--                    <n-form-item :label="$t('fathersLastName')"  path="fatherLastName">-->
                <!--                        <n-input v-model:value="form.fatherLastName" :placeholder="$t('PleaseInput')"/>-->
                <!--                    </n-form-item>-->
                <!--                  </div>-->
                <!--                  <div class="col-span-6 sm:col-span-2">-->
                <!--                    <n-form-item :label="$t('fathersNationality')"  path="fatherNationality">-->
                <!--                        <n-input v-model:value="form.fatherNationality" :placeholder="$t('PleaseInput')"/>-->
                <!--                    </n-form-item>-->
                <!--                  </div>-->
            </div>
            </section>

            <section class="application-card" v-if="!form.isStudent">
            <h2 class="section-title">{{ $t('degreeEducation') }}</h2>
            <div class="grid grid-cols-6 gap-4" v-if="!form.isStudent">
                <!-- diploma -->
                <div class="col-span-6 sm:col-span-3">
                    <n-form-item :label="$t('diploma')" path="diploma">
                        <n-input v-model:value="form.diploma" :placeholder="$t('PleaseInput')"/>
                    </n-form-item>
                </div>
                <!-- specialization -->
                <div class="col-span-6 sm:col-span-3">
                    <n-form-item :label="$t('specialization')" path="specialization">
                        <n-input v-model:value="form.specialization" :placeholder="$t('PleaseInput')"/>
                    </n-form-item>
                </div>
                <!-- placeOfTraining -->
                <div class="col-span-6 sm:col-span-2">
                    <n-form-item :label="$t('placeOfTraining')" path="placeOfTraining">
                        <n-input v-model:value="form.placeOfTraining" :placeholder="$t('PleaseInput')"/>
                    </n-form-item>
                </div>
                <!-- graduationYear -->
                <div class="col-span-6 sm:col-span-2">
                    <n-form-item :label="$t('graduationYear')" path="graduationYear">
                        <n-input v-model:value="form.graduationYear" :placeholder="$t('PleaseInput')"/>
                    </n-form-item>
                </div>
                <!-- gradeOfThesis -->
                <div class="col-span-6 sm:col-span-2">
                    <n-form-item :label="$t('thesisGrade')" path="gradeOfThesis">
                        <n-input v-model:value="form.gradeOfThesis" :placeholder="$t('PleaseInput')"/>
                    </n-form-item>
                </div>
            </div>


            <div class="section-separator"></div>
            <h3 class="section-title section-title-small">{{ $t('theologicalEducation') }}</h3>
            <div class="grid grid-cols-6 gap-4" v-if="!form.isStudent">
                <div class="col-span-6 sm:col-span-3">
                    <n-form-item :label="$t('diploma')" path="theoDiploma">
                        <n-input v-model:value="form.theoDiploma" :placeholder="$t('PleaseInput')"/>
                    </n-form-item>
                </div>
                <div class="col-span-6 sm:col-span-3">
                    <n-form-item :label="$t('Nameoftheschool')"   path="theoSchoolName">
                        <n-input v-model:value="form.theoSchoolName" :placeholder="$t('PleaseInput')"/>
                    </n-form-item>
                </div>
                <div class="col-span-6 sm:col-span-3">
                    <n-form-item :label="$t('placeOfTraining')" path="theoPlaceOfTraining">
                        <n-input v-model:value="form.theoPlaceOfTraining" :placeholder="$t('PleaseInput')"/>
                    </n-form-item>
                </div>
                <div class="col-span-6 sm:col-span-3">
                    <n-form-item :label="$t('DurationOfTraining')" path="theoDuration">
                        <n-input v-model:value="form.theoDuration" :placeholder="$t('PleaseInput')"/>
                    </n-form-item>
                </div>
            </div>
            </section>



            <!--            <n-divider style="margin-top:48px;" />-->
            <!--            <h2   class=" mb-4 text-base sm:text-xl   font-medium mt-1 transition-all"  >{{ $t('spouse') }}:</h2>-->

            <!--            <div class="grid grid-cols-6 gap-4">-->
            <!--                &lt;!&ndash; title &ndash;&gt;-->
            <!--                <div class="col-span-6 sm:col-span-2">-->
            <!--                    <n-form-item  :label="$t('title')"   path="spouseTitle">-->
            <!--                        <n-select-->
            <!--                            v-model:value="form.spouseTitle"-->
            <!--                            :options="titleOptions"-->
            <!--                            :placeholder="$t('SelectPlaceHolder')"-->
            <!--                        />-->
            <!--                    </n-form-item>-->
            <!--                </div>-->
            <!--                &lt;!&ndash; first name &ndash;&gt;-->
            <!--                <div class="col-span-6 sm:col-span-2">-->
            <!--                    <n-form-item :label="$t('firstName')" path="spouseFirstName">-->
            <!--                        <n-input v-model:value="form.spouseFirstName" :placeholder="$t('PleaseInput')"/>-->
            <!--                    </n-form-item>-->
            <!--                </div>-->
            <!--                &lt;!&ndash; last name &ndash;&gt;-->
            <!--                <div class="col-span-6 sm:col-span-2">-->
            <!--                    <n-form-item :label="$t('lastName')" path="spouseLastName">-->
            <!--                        <n-input v-model:value="form.spouseLastName" :placeholder="$t('PleaseInput')"/>-->
            <!--                    </n-form-item>-->
            <!--                </div>-->
            <!--                &lt;!&ndash; nationality &ndash;&gt;-->
            <!--                <div class="col-span-6 sm:col-span-2">-->
            <!--                    <n-form-item :label="$t('spouseNationality')" path="spouseNationality">-->
            <!--                        <n-input v-model:value="form.spouseNationality" :placeholder="$t('PleaseInput')"/>-->
            <!--                    </n-form-item>-->
            <!--                </div>-->
            <!--                &lt;!&ndash; denomination &ndash;&gt;-->
            <!--                <div class="col-span-6 sm:col-span-2">-->
            <!--                    <n-form-item :label="$t('spouseDenomination')" path="spouseDenomination">-->
            <!--                        <n-input v-model:value="form.spouseDenomination" :placeholder="$t('PleaseInput')"/>-->
            <!--                    </n-form-item>-->
            <!--                </div>-->
            <!--                &lt;!&ndash; profession &ndash;&gt;-->
            <!--                <div class="col-span-6 sm:col-span-2">-->
            <!--                    <n-form-item :label="$t('spouseProfession')" path="spouseProfession">-->
            <!--                        <n-input v-model:value="form.spouseProfession" :placeholder="$t('PleaseInput')"/>-->
            <!--                    </n-form-item>-->
            <!--                </div>-->
            <!--            </div>-->


            <section class="application-card">
            <h2 class="section-title">{{ $t('studyForm') }}</h2>
            <p class="section-subtitle">{{ $t('studyFormDescription') }}</p>
            <n-form-item path="studyForm">
                <n-radio-group v-model:value="form.is_full_time" class="choice-grid">
                    <n-space vertical class="choice-space">
                        <n-radio class="choice-radio" value="FullTime">
                            <span class="study-option-copy">
                                <strong>{{ $t('fullTime') }}</strong>
                                <small>{{ $t('fullTimeDescription') }}</small>
                            </span>
                        </n-radio>
                        <n-radio class="choice-radio" value="PartTime">
                            <span class="study-option-copy">
                                <strong>{{ $t('partTime') }}</strong>
                                <small>{{ $t('partTimeDescription') }}</small>
                            </span>
                        </n-radio>
                        <n-radio class="choice-radio" value="GuestStudent">
                            <span class="study-option-copy">
                                <strong>{{ $t('guestStudentStatus') }}</strong>
                                <small>{{ $t('guestStudentStatusDescription') }}</small>
                            </span>
                        </n-radio>
                    </n-space>
                </n-radio-group>
            </n-form-item>
            </section>

            <!--            <n-divider style="margin-top:48px;" />-->
            <!--            <h2   class=" mb-4 text-base sm:text-xl   font-medium mt-1 transition-all"  >{{ $t('participationType') }}:</h2>-->
            <!--             <n-form-item path="participationType">-->
            <!--                <n-radio-group v-model:value="form.participationType">-->
            <!--                    <n-space vertical>-->
            <!--                        <n-radio value="online">{{ $t('online') }}</n-radio>-->
            <!--                        <n-radio value="offline">{{ $t('offline') }}</n-radio>-->
            <!--                    </n-space>-->
            <!--                </n-radio-group>-->
            <!--            </n-form-item>-->

            <section class="application-card">
                <div class="section-heading-row">
                    <div>
                        <h2 class="section-title">{{ $t('Courses') }}</h2>
                        <p class="section-subtitle">{{ $t('courseLimitDescription', { max: MAX_COURSES }) }}</p>
                    </div>
                    <span class="course-counter" :class="{ full: selectedCourseCount >= MAX_COURSES }">
                        {{ selectedCourseCount }} / {{ MAX_COURSES }} {{ $t('Courses') }}
                    </span>
                </div>
            <n-form-item
                label=""
                path="courses"
            >

            <Courses
                v-model:course-list="form.courses"
                :all-courses="data.courses ?? []"
                :max-courses="MAX_COURSES"
                :other-selected-count="form.other_courses.length"
            />
             </n-form-item>
                <p v-if="selectedCourseCount >= MAX_COURSES" class="limit-note">
                    {{ $t('courseLimitReached', { max: MAX_COURSES }) }}
                </p>
            </section>

            <section class="application-card accordion-card">
            <n-form-item
                label=""
                path="other_courses"
            >
            <OtherCourses
                v-model:course-list="form.other_courses"
                :all-courses="data.other_courses ?? []"
                :max-courses="MAX_COURSES"
                :other-selected-count="form.courses.length"
            />
             </n-form-item>
            </section>


            <!--            <n-divider style="margin-top:48px;" />-->
            <!--            <h2   class=" mb-4 text-base sm:text-xl   font-medium mt-1 transition-all"  >{{ $t('moduleSelection') }}:</h2>-->
            <!--             <n-form-item path="modules">-->
            <!--                <n-checkbox-group v-model:value="form.modules">-->
            <!--                    <n-space vertical>-->
            <!--                        <n-checkbox value="arabic">Arabic III</n-checkbox>-->
            <!--                        <n-checkbox value="persian">Persian III</n-checkbox>-->
            <!--                        <n-checkbox value="beliefs">{{$t('foundationsOfBelief3')}}</n-checkbox>-->
            <!--                        <n-checkbox value="quranWords">{{$t('wordsOfQuranAndRoots3')}}</n-checkbox>-->
            <!--                        <n-checkbox value="logic">{{$t('logic2')}}I</n-checkbox>-->
            <!--                        <n-checkbox value="legalProvisions">{{$t('islamicLegalProvisions3')}}</n-checkbox>-->
            <!--                        <n-checkbox value="quranicIntro">{{$t('introQuranicStudies')}}</n-checkbox>-->
            <!--                        <n-checkbox value="recitation">{{$t('recitationIntonationQuran1')}}</n-checkbox>-->
            <!--                        <n-checkbox value="legalTheory">{{$t('introIslamicLegalNorms')}}</n-checkbox>-->
            <!--                    </n-space>-->
            <!--                </n-checkbox-group>-->
            <!--            </n-form-item>-->

            <section class="application-card" v-if="!form.isStudent">
            <h2 class="section-title">{{ $t('documents') }}</h2>
            <n-space vertical size="large" class="documents-grid">
                <n-form-item path="passportFiles" >
                    <div>
                        <span>{{$t('Passport')}}</span><br/>
                        <n-upload
                            v-model:file-list="form.passportFiles"
                            :accept="'.pdf,.jpg,.jpeg,.png,.doc,.docx'"
                            :max="1"
                            list-type="text"
                        >
                            <n-button>{{ $t('ChooseFile') }}</n-button>
                        </n-upload>
                    </div>
                </n-form-item>

                <n-form-item path="certificateFiles" >
                    <div>
                        <span>{{$t('Certificates')}}</span><br/>
                        <n-upload
                            v-model:file-list="form.certificateFiles"
                            :accept="'.pdf,.jpg,.jpeg,.png,.doc,.docx'"
                            :max="1"
                            list-type="text"
                        >
                            <n-button>{{ $t('ChooseFile') }}</n-button>
                        </n-upload>
                    </div>
                </n-form-item>

                <n-form-item path="photoFiles" >
                    <div>
                        <span>{{$t('biometricPhoto') }}</span><br/>
                        <n-upload
                            v-model:file-list="form.photoFiles"
                            :accept="'.pdf,.jpg,.jpeg,.png,.doc,.docx'"
                            :max="1"
                            list-type="text"
                        >
                            <n-button>{{ $t('ChooseFile') }}</n-button>
                        </n-upload>
                    </div>
                </n-form-item>

                <n-form-item path="cvFiles" >
                    <div>
                        <span>CV</span><br/>
                        <n-upload
                            v-model:file-list="form.cvFiles"
                            :accept="'.pdf,.jpg,.jpeg,.png,.doc,.docx'"
                            :max="1"
                            list-type="text"
                        >
                            <n-button>{{ $t('ChooseFile') }}</n-button>
                        </n-upload>
                    </div>
                </n-form-item>

            </n-space>
            </section>


            <section class="application-card compact-card">
            <h2 class="section-title section-title-small">{{$t('furtherQuestions') }}</h2>
            <n-form-item path="additionalQuestions">
                <n-input
                    v-model:value="form.additionalQuestions"
                    type="textarea"
                    autosize
                    :placeholder="$t('yourMessageOrQuestion')"
                    style="min-height:120px;"
                />
            </n-form-item>
            </section>

            <!--            <n-divider style="margin-top:48px;" />-->
            <!--            <h2   class=" mb-4 text-base sm:text-xl   font-medium mt-1 transition-all"  >{{ $t('paymentType') }}:</h2>-->
            <!--            <n-form-item path="participationType">-->
            <!--                <n-radio-group v-model:value="form.is_full_time" name="is_full_time">-->
            <!--                    <n-space vertical>-->
            <!--                        <n-radio :value="1">{{ $t('fullTime') }}</n-radio>-->
            <!--                        <n-radio :value="0">{{ $t('partTime') }}</n-radio>-->
            <!--                    </n-space>-->
            <!--                </n-radio-group>-->
            <!--            </n-form-item>-->


            <section class="application-card">
            <h2 class="section-title">{{ $t('paymentType') }}</h2>
            <p class="section-subtitle">{{ $t('paymentTypeDescription') }}</p>
            <n-form-item path="participationType">
                <n-radio-group v-model:value="form.is_installment" name="is_installment" class="choice-grid payment-choice-grid">
                    <n-space vertical class="choice-space">
                        <n-radio class="choice-radio" :value="0">{{ $t('Unique') }}</n-radio>
                        <n-radio class="choice-radio" :value="1">{{ $t('installment') }}</n-radio>
                    </n-space>
                </n-radio-group>
            </n-form-item>

            <div class="price-box" aria-live="polite">
                <div>
                    <span class="price-label">{{ $t('yourPrice') }} · {{ form.is_installment ? $t('installment') : $t('Unique') }}</span>
                    <strong class="price-amount">{{ formatCurrency(payableTotal) }}</strong>
                    <span class="price-for">{{ $t('priceForCourses', { count: selectedCourseCount }) }}</span>
                </div>
                <div v-if="courseSubtotal > activePriceCap" class="price-saving">
                    <span>{{ $t('individualPriceTotal') }} <s>{{ formatCurrency(courseSubtotal) }}</s></span>
                    <strong>{{ $t('packageSaving', { amount: formatCurrency(priceSavings) }) }}</strong>
                </div>
                <p v-else class="price-note">
                    {{ $t('priceCapNote', { cap: formatCurrency(activePriceCap) }) }}
                </p>
            </div>
            </section>

            <section class="application-card consent-card">
            <h2 class="section-title section-title-small">{{$t('consentAndNewsletter') }}</h2>
            <n-space vertical>
                <n-checkbox
                    v-model:checked="form.consent"
                    :required="true"
                >
                    {{$t('agreeInfoStorage') }}
                </n-checkbox>
                <n-checkbox v-model:checked="form.newsletter">
                    {{$t('newsletter') }}
                </n-checkbox>
            </n-space>
            <n-collapse-transition :show="!!errorMsg" class="w-full">
                <n-alert
                    v-if="errorMsg"
                    type="error"
                    :show-icon="true"
                    class="mb-4 w-full"
                    :bordered="false"
                >
                    {{ errorMsg }}
                </n-alert>
            </n-collapse-transition>

            <div id="recaptcha-main" class="captcha-wrap"></div>
            <p v-if="recaptchaFormError" class="text-red-600 text-sm mt-1">{{ recaptchaFormError }}</p>

            <n-form-item class="submit-item">
                <n-button
                    class="submit-button"
                    type="primary"
                    :disabled="!form.consent || loading"
                    @click="handleSubmit"
                    :loading="loading"
                    block
                >
                    {{$t('submit') }}
                </n-button>
            </n-form-item>
            </section>

            <!--            <transition name="fade-slide" mode="out-in">-->
            <!--      -->
            <!--            </transition>-->


        </n-form>

    </BaseLayout>


    <n-modal
        v-model:show="showDialog"
        preset="card"
        class="payment-modal"
        :title="$t('orderSummaryPayment')"
        size="large"
        :style="{ maxWidth: '750px' }"
        :closable="true"
        :mask-closable="false"
        @before-leave="handlePaymentModalBeforeLeave"
        @after-leave="handlePaymentModalAfterLeave"
    >
        <div v-if="responseData" class="payment-modal-content">
            <n-table class="modal-course-table" size="small">
                <thead>
                <tr>
                    <th>#</th>
                    <th>{{ $t('course') }}</th>
                    <th>{{ $t('mode') }}</th>
                    <th>{{ $t('price') }} </th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(course, i) in responseData.courses" :key="'course-' + course.id">
                    <td>{{ i + 1 }}</td>
                    <td>{{ course.name }}</td>
                    <td><span class="modal-mode-badge">{{ $t('online') }}</span></td>
                    <td>{{ formatCurrency(coursePrice(course.price)) }}</td>
                </tr>
                <tr v-for="(course, i) in (responseData.other_courses || [])" :key="'other-course-' + course.id">
                    <td>{{ responseData.courses.length + i + 1 }}</td>
                    <td>{{ course.name }}</td>
                    <td><span class="modal-mode-badge">{{ $t('offline') }}</span></td>
                    <td>{{ formatCurrency(coursePrice(course.price)) }}</td>
                </tr>
                </tbody>
            </n-table>

            <div class="modal-price-summary">
                <span>{{ $t('grandTotal') }}</span>
                <strong>{{ formatCurrency(coursePrice(responseData.order.total_price)) }}</strong>
                <small v-if="coursePrice(responseData.savings) > 0">
                    {{ $t('packageSaving', { amount: formatCurrency(coursePrice(responseData.savings)) }) }}
                </small>
            </div>
            <div
                v-if="!responseData.payment_link &&  responseData.order?.is_installment===0 && false"
                class="my-4 rounded-lg border border-yellow-200 bg-yellow-50 px-4 py-4 flex flex-col items-center text-center shadow-sm"
            >
                <div class="mb-2 flex items-center justify-center">
                    <svg class="w-6 h-6 mr-2 text-yellow-500" fill="none" viewBox="0 0 20 20">
                        <circle cx="10" cy="10" r="9" stroke="currentColor" stroke-width="2" fill="#fffbe6"/>
                        <line x1="10" y1="7" x2="10" y2="13" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
                        <circle cx="10" cy="16" r="1.1" fill="currentColor"/>
                    </svg>
                    <span class="text-base font-semibold text-yellow-700"> {{ $t('paymentOffline')}} </span>
                </div>
                <div class="text-yellow-800 text-sm mb-2">
                    {{ $t('paypalInstruction')}}
                </div>
                <input
                    class="w-full px-2 py-1 rounded bg-gray-100 border border-gray-200 text-gray-700 font-mono text-sm text-center mb-1 focus:outline-none focus:ring-2 focus:ring-yellow-200"
                    :value="responseData.pay_account"
                    readonly
                />

            </div>
<!--            <div v-if="responseData.order?.is_installment" class="modal-bank-card">-->
            <div class="modal-bank-card">
                <div class="modal-section-heading">
                    <h2>{{ $t('directDebit') }}</h2>
                    <p>{{ $t('directDebitMandate') }}</p>
                </div>

                <n-form-item :label="$t('accountHolder')" path="account_holder">
                    <n-input v-model:value="form.account_holder" type="text" :placeholder="$t('PleaseInput')" />
                </n-form-item>
                <n-form-item label="IBAN" path="iban">
                    <n-input v-model:value="form.iban" type="text" :placeholder="$t('PleaseInput')" />
                </n-form-item>

                <p class="modal-debit-notice">{{ $t('noticeDebit') }}</p>
                <n-space vertical class="modal-debit-consent">
                    <n-checkbox v-model:checked="isAgreed">
                        {{ $t('agreeDebit') }}
                    </n-checkbox>

                </n-space>
            </div>

            <div id="recaptcha-modal" class="mt-2"></div>
            <p v-if="recaptchaEmailError" class="modal-error-text">{{ recaptchaEmailError }}</p>



            <div class="modal-actions">
                <!--                    v-if="responseData.payment_link || responseData.order?.is_installment"-->

                <n-button
                    class="modal-primary-button"
                    type="primary"
                    :disabled="(responseData.order?.is_installment &&!isAgreed)|| loadingRequest"
                    @click="handlePayment"
                >
                    {{responseData.order?.is_installment ?$t('agreeAndPay'): $t('payNow')}}
                </n-button>
                <n-button
                    class="modal-secondary-button"
                    @click="showDialog = false"
                >
                    {{ responseData.payment_link? $t('cancel'):$t('closes') }}
                </n-button>
            </div>
        </div>
    </n-modal>

</template>


<script setup>
import BaseLayout from "../components/BaseLayout.vue";

import {ref, computed, onMounted, nextTick} from 'vue';
import { useI18n } from 'vue-i18n'
const { t } = useI18n();
import {
    NForm,
    NFormItem,
    NInput,
    NSelect,
    NDatePicker,
    NButton,
    NRadioGroup,
    NRadio,
    NGi,
    NCheckbox, NSpace,
 } from 'naive-ui'
import { useMessage} from 'naive-ui'


import Courses from "../components/Courses.vue";
import OtherCourses from "../components/OtherCourses.vue";
import axios from "axios";
const message = useMessage();
const props = defineProps({
    data: Object
});

const MAX_COURSES = Number(props.data?.settings?.max_courses ?? 11)
const PRICE_CAPS = {
    single: Number(props.data?.settings?.price_caps?.single ?? 390),
    installment: Number(props.data?.settings?.price_caps?.installment ?? 450)
}

const formRef = ref(null)
const showDialog = ref(false)
const responseData = ref(null)
const loading = ref(false)
const loadingRequest = ref(false)
const errorMsg = ref('');
const isAgreed = ref(false)
const recaptchaFormError = ref('')
const recaptchaEmailError = ref('')
const YOUR_SITE_KEY=ref(props.data.sitekey)
const MAX_FILE_SIZE = 2 * 1024 * 1024
const widgetMain = ref(null);
const widgetModal = ref(null);

function coursePrice(value) {
    const raw = String(value ?? 0)
    const normalized = raw.includes(',')
        ? raw.replace(/\./g, '').replace(',', '.')
        : raw
    return Number(normalized) || 0
}

function formatCurrency(value) {
    return new Intl.NumberFormat('de-DE', {
        style: 'currency',
        currency: 'EUR'
    }).format(value)
}

const selectedCourseCount = computed(() =>
    form.value.courses.length + form.value.other_courses.length
)
const courseSubtotal = computed(() => [
    ...form.value.courses,
    ...form.value.other_courses
].reduce((total, course) => total + coursePrice(course.price), 0))
const activePriceCap = computed(() =>
    form.value.is_installment ? PRICE_CAPS.installment : PRICE_CAPS.single
)
const payableTotal = computed(() => Math.min(courseSubtotal.value, activePriceCap.value))
const priceSavings = computed(() => Math.max(courseSubtotal.value - payableTotal.value, 0))

axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest'

async function postWithCsrfRetry(url, data) {
    try {
        return await axios.post(url, data)
    } catch (error) {
        if (error?.response?.status !== 419) throw error

        // A rejected CSRF request never reaches the controller, so retrying it
        // after Laravel issues fresh session/XSRF cookies cannot duplicate data.
        await axios.get('/', { headers: { Accept: 'text/html' } })
        return axios.post(url, data)
    }
}

function requestErrorMessage(error, fallbackKey = 'something_went_wrong') {
    const status = error?.response?.status
    const validationErrors = error?.response?.data?.errors

    if (status === 422 && validationErrors) {
        if (validationErrors['g-recaptcha-response']) {
            return t('recaptcha_verification_failed')
        }

        if (validationErrors.courses || validationErrors.other_courses) {
            return selectedCourseCount.value < 1
                ? t('PleaseSelectOne')
                : t('courseLimitReached', { max: MAX_COURSES })
        }

        return Object.values(validationErrors).flat().join(' ')
    }

    if (status === 419) return t('session_expired')
    if (status === 413) return t('request_too_large')

    return t(fallbackKey)
}

function resetRecaptcha(widgetRef) {
    if (widgetRef.value === null || !window.grecaptcha) return

    try {
        grecaptcha.reset(widgetRef.value)
    } catch (error) {
        console.error('Failed to reset reCAPTCHA', error)
    }
}

function handlePaymentModalBeforeLeave() {
    recaptchaEmailError.value = ''
    resetRecaptcha(widgetModal)
}

function handlePaymentModalAfterLeave() {
    // NModal removes its content after the leave transition. The next time it
    // opens, reCAPTCHA must be rendered into the newly-created container.
    widgetModal.value = null
}

function renderRecaptchaIfNeeded(elementId, widgetRef) {
    if (widgetRef.value !== null) return Promise.resolve(widgetRef.value)
    return new Promise((resolve, reject) => {
        const tryRender = () => {
            try {
                const el = document.getElementById(elementId)
                if (!el) {
                    reject(new Error(`${elementId} placeholder not found`))
                    return
                }
                widgetRef.value = grecaptcha.render(el, { sitekey: YOUR_SITE_KEY.value })

                resolve(widgetRef.value)
            } catch (e) {
                reject(e)
            }
        }
        const start = Date.now()
        const maxWaitMs = 5000
        const interval = setInterval(() => {
            if (document.getElementById(elementId)) {
                clearInterval(interval)
                if (window.grecaptcha && grecaptcha.ready) {


                    grecaptcha.ready(() => tryRender())
                } else {
                    tryRender()
                }
            } else if (Date.now() - start > maxWaitMs) {
                clearInterval(interval)
                reject(new Error(`${elementId} placeholder not found in time`))
            }
        }, 100)
    })
}

onMounted(() => {
    YOUR_SITE_KEY.value = props.data.sitekey
    renderRecaptchaIfNeeded('recaptcha-main', widgetMain).catch((e) => {
        console.error('Failed to initialize reCAPTCHA on mount', e)
    })
});
const form = ref({
    isStudent:1,
    title: null,
    firstName: '',
    lastName: '',
    street: '',
    houseNumber: '',
    postalCode: '',
    city: '',
    phone: '',
    email: '',
    birthDate: null,
    placeOfBirth: '',
    // maritalStatus: '',
    nationality: '',
    denomination: '',
    // fatherFirstName: '',
    // fatherLastName: '',
    // fatherNationality: '',
    //   Degree/Education
    diploma: '',
    specialization: '',
    placeOfTraining: '',
    graduationYear: '',
    gradeOfThesis: '',
    //   Theological education
    theoDiploma: '',
    theoSchoolName: '',
    theoPlaceOfTraining: '',
    theoDuration: '',
    //   Spouse
    // spouseTitle: '',
    // spouseFirstName: '',
    // spouseLastName: '',
    // spouseNationality: '',
    // spouseDenomination: '',
    // spouseProfession: '',

    // Study Form
    studyForm: 'full-time',
    // modules: [],
    passportFiles: [],
    certificateFiles: [],
    photoFiles: [],
    cvFiles: [],
    additionalQuestions: '',
    is_full_time:'FullTime',
    is_installment:0,
    account_holder: '',
    iban: '',
    consent: false,
    newsletter: false,
    courses: [],
    other_courses: []
})
const titleOptions = computed(() => [
    { label: t('Mister'), value: 'mister' },
    { label: t('Woman'), value: 'woman' },
]);

const rules = computed(() => {
    const r = {
        title: { required: true, message: t('pleaseFill'), trigger: 'blur' },
        firstName: { required: true, message: t('pleaseFill'), trigger: 'blur' },
        lastName: { required: true, message: t('pleaseFill'), trigger: 'blur' },
        street: { required: true, message: t('pleaseFill'), trigger: 'blur' },
        houseNumber: { required: true, message: t('pleaseFill'), trigger: 'blur' },
        postalCode: { required: true, message: t('pleaseFill'), trigger: 'blur' },
        city: { required: true, message: t('pleaseFill'), trigger: 'blur' },
        phone: { required: true, message: t('pleaseFill'), trigger: 'blur' },
        email: { required: true,
            validator: (_, value) => {
                if (!value) return true
                const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
                if (!emailRegex.test(value)) {
                    return new Error(t('invalidEmail')) //
                }
                return true
            },
            message: t('pleaseFill'), trigger: 'blur' },
        // maritalStatus: { required: true, message: t('pleaseFill'), trigger: 'blur' },

        courses: [
            {
                validator: (rule, value) => {
                    if (selectedCourseCount.value < 1) return new Error(t('PleaseSelectOne'))
                    if (selectedCourseCount.value > MAX_COURSES) {
                        return new Error(t('courseLimitReached', { max: MAX_COURSES }))
                    }
                    return true
                },
                trigger: ['change', 'blur'],
            },
        ],

    }
    if (form.value.isStudent !== 1) {
        r.birthDate = { required: true, message: t('pleaseFill'), trigger: ['change', 'blur'] }
        r.placeOfBirth = { required: true, message: t('pleaseFill'), trigger: 'blur' }
        r.nationality= { required: true, message: t('pleaseFill'), trigger: 'blur' }
        r.denomination= { required: true, message: t('pleaseFill'), trigger: 'blur' }
        r.diploma= { required: true, message: t('pleaseFill'), trigger: 'blur' }
        r.specialization= { required: true, message: t('pleaseFill'), trigger: 'blur' }
        r.placeOfTraining= { required: true, message: t('pleaseFill'), trigger: 'blur' }
        r.graduationYear= { required: true, message: t('pleaseFill'), trigger: 'blur' }
        r.gradeOfThesis= { required: true, message: t('pleaseFill'), trigger: 'blur' }
    }

    if (form.value?.is_installment === 1) {
        r.account_holder = { required: true, message: t('pleaseFill'), trigger: 'blur' }
        r.iban = { required: true, message: t('pleaseFill'), trigger: 'blur' }
    }

    return r
})
const handlePayment = async () => {
    // if (responseData.value && responseData.value?.order?.is_installment) {
    if (responseData.value  ) {
        console.log("this is installment")
        recaptchaEmailError.value = ''
        if (!form.value.account_holder || !form.value.iban) {
            message.error(t('pleaseFill'))
            return
        }
        if (widgetModal.value === null) {
            try {
                await renderRecaptchaIfNeeded('recaptcha-modal', widgetModal)
            } catch (e) {
                console.error('Failed to render modal reCAPTCHA before payment', e);
                message.error(t('recaptcha_please_complete'))
                return
            }
        }
        const tokenModal = grecaptcha.getResponse(widgetModal.value);
        if (!tokenModal) {
            recaptchaEmailError.value = t('recaptcha_please_complete');
            return;
        }
        loadingRequest.value = true
        try {
            const formData = {
                order_id: responseData.value?.order?.id,
                'g-recaptcha-response': tokenModal,
                account_holder: form.value.account_holder,
                iban: form.value.iban
            }
             await postWithCsrfRetry('/order/send-email', formData)
             message.success(t('emailwassuccessfullysent'));
            if (!(responseData.value && responseData.value?.payment_link)) {
                showDialog.value=false
            }
         } catch (error) {
            message.error(requestErrorMessage(error, 'emailwasnotsent'))
            console.error(error)
        } finally {
            resetRecaptcha(widgetModal)
            loadingRequest.value = false
        }

    }


    if (responseData.value && responseData.value?.payment_link) {
        window.location.href = responseData.value.payment_link
    }
}



const handleSubmit =  async () => {

    recaptchaFormError.value = ''

    if (selectedCourseCount.value > MAX_COURSES) {
        errorMsg.value = t('courseLimitReached', { max: MAX_COURSES })
        return
    }

    try {
        await renderRecaptchaIfNeeded('recaptcha-main', widgetMain)
    } catch (e) {
        recaptchaFormError.value = t('recaptcha_failed_to_load')
        return
    }

    const tokenMain = grecaptcha.getResponse(widgetMain.value);

    if (!tokenMain) {
        recaptchaFormError.value = t('recaptcha_please_check')
        return
    }
    formRef.value?.validate(async (errors) => {
        if (!errors) {
            if (form.value.consent) {

                // Files are optional. Check the size only for files the user selected.
                const selectedFiles = [
                    ...form.value.cvFiles,
                    ...form.value.photoFiles,
                    ...form.value.certificateFiles,
                    ...form.value.passportFiles,
                ].map(item => item.file || item)
                const oversizedFile = selectedFiles.find(file => file?.size > MAX_FILE_SIZE)
                if (oversizedFile) {
                    errorMsg.value = t('file_too_large', { name: oversizedFile.name || '' })
                    return
                }

                const {
                    isStudent,
                    email,
                    cvFiles,
                    photoFiles,
                    certificateFiles,
                    passportFiles,
                    courses,
                    other_courses,
                    is_full_time,
                    is_installment,
                    ...rest
                } = form.value

                const transformedCourses = form.value.courses.map(course => ({
                    course_id: course.id,
                }))

                const transformedOtherCourses = form.value.other_courses
                    .filter(course => course.selected)
                    .map(course => ({
                        course_id: course.id,
                    }))


                try {
                    errorMsg.value =null;
                    loading.value = true
                    const formData = new FormData()
                    formData.append('g-recaptcha-response', tokenMain);
                    formData.append('email', email)
                    formData.append('is_student', isStudent)
                    formData.append('is_full_time', is_full_time)
                    formData.append('is_installment', is_installment)
                    if (cvFiles[0]) formData.append('cv', cvFiles[0].file || cvFiles[0])
                    if (photoFiles[0]) formData.append('photo', photoFiles[0].file || photoFiles[0])
                    if (certificateFiles[0]) formData.append('certificate', certificateFiles[0].file || certificateFiles[0])
                    if (passportFiles[0]) formData.append('passport', passportFiles[0].file || passportFiles[0])
                    transformedCourses.forEach((course, index) => {
                        formData.append(`courses[${index}][course_id]`, course.course_id);
                    });
                    transformedOtherCourses.forEach((course, index) => {
                        formData.append(`other_courses[${index}][course_id]`, course.course_id);
                    });
                    formData.append('user_details', JSON.stringify(rest))
                    // ... append form fields!
                    const { data } = await postWithCsrfRetry('/order/create-order', formData);
                    responseData.value = {
                        is_student: isStudent,
                        courses:form.value.courses,
                        other_courses: form.value.other_courses.filter(course => course.selected),
                        total_price: data.order.total_price,
                        course_subtotal: data.course_subtotal,
                        price_cap: data.price_cap,
                        savings: data.savings,
                        payment_link: data.payment_link,
                        pay_account: data.pay_account??'DE84 1001 1001 2385 3054 17',
                        is_full_time:data.is_full_time,
                        is_installment:data.is_installment,
                        order:data.order
                    }

                    // Ensure modal content is rendered by populating responseData
                    // responseData.value = data
                    showDialog.value = true
                    await nextTick()
                    try {
                        await renderRecaptchaIfNeeded('recaptcha-modal', widgetModal);
                    } catch (e) {
                        console.error('Failed to render modal reCAPTCHA', e)
                        recaptchaEmailError.value = t('recaptcha_failed_render_modal')
                    }

                } catch (error) {
                    errorMsg.value = requestErrorMessage(error)

                } finally {
                    // reCAPTCHA tokens are single-use. Always clear the visual
                    // checkmark so a later submission cannot reuse this token.
                    resetRecaptcha(widgetMain)
                    loading.value = false
                }


            } else {

            }



        }
    })
}
</script>
<style>
.application-form {
    display: grid;
    gap: 24px;
}

.application-card {
    padding: 36px 40px;
    border: 1px solid var(--border);
    border-radius: 18px;
    background: var(--surface);
}

.first-card {
    box-shadow: 0 12px 28px rgba(30, 40, 20, .06);
}

.compact-card {
    padding-top: 30px;
    padding-bottom: 30px;
}

.accordion-card {
    padding-top: 28px;
    padding-bottom: 28px;
}

.section-title {
    margin: 0 0 6px;
    color: var(--text);
    font: 600 22px/1.3 var(--font-heading);
}

.section-title-small {
    font-size: 18px;
}

.section-subtitle {
    margin: 0 0 22px;
    color: var(--muted);
    font-size: 13.5px;
    line-height: 1.55;
}

.section-separator {
    height: 1px;
    margin: 10px 0 28px;
    background: var(--border);
}

.section-heading-row {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 18px;
}

.course-counter {
    flex: none;
    padding: 7px 14px;
    border-radius: 999px;
    background: var(--accent-tint-2);
    color: var(--accent-text);
    font-size: 13px;
    font-weight: 700;
    white-space: nowrap;
}

.course-counter.full {
    background: var(--warn-bg);
    color: var(--warn-text);
}

.limit-note {
    margin: 2px 0 0;
    color: var(--warn-text);
    font-size: 12.5px;
}

.application-form .n-form-item:last-child {
    margin-bottom: 0;
}

.application-form .n-input,
.application-form .n-base-selection {
    --n-border: 1px solid var(--border-input) !important;
    --n-border-hover: 1px solid var(--accent) !important;
    --n-border-focus: 1px solid var(--accent) !important;
    --n-box-shadow-focus: 0 0 0 2px var(--accent-tint-2) !important;
    --n-border-radius: 10px !important;
}

.choice-grid,
.choice-space {
    width: 100%;
}

.choice-space {
    display: grid !important;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 14px !important;
}

.choice-space > .n-space__item {
    margin: 0 !important;
}

.choice-radio {
    width: 100%;
    min-height: 58px;
    align-items: flex-start !important;
    padding: 17px 18px;
    border: 1.5px solid var(--border);
    border-radius: 12px;
    background: var(--surface);
    transition: border-color .15s ease, background-color .15s ease;
}

.choice-radio.n-radio--checked {
    border-color: var(--accent);
    background: var(--accent-tint-2);
}

.choice-radio .n-radio__dot {
    margin-top: 2px;
}

.choice-radio .n-radio__label {
    color: var(--text);
    font-size: 14px;
    font-weight: 600;
}

.study-option-copy {
    display: block;
}

.study-option-copy strong,
.study-option-copy small {
    display: block;
}

.study-option-copy strong {
    font-size: 14.5px;
    font-weight: 600;
}

.study-option-copy small {
    margin-top: 3px;
    color: var(--muted);
    font-size: 12.5px;
    font-weight: 400;
    line-height: 1.4;
}

.documents-grid,
.documents-grid > .n-space__item {
    width: 100%;
}

.price-box {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 28px;
    margin-top: 10px;
    padding: 26px 28px;
    border: 1px solid var(--accent-border);
    border-radius: 16px;
    background: var(--accent-tint);
}

.price-label {
    display: block;
    color: #555;
    font-size: 12px;
    font-weight: 700;
    letter-spacing: .08em;
    text-transform: uppercase;
}

.price-amount {
    display: block;
    margin: 6px 0;
    color: var(--accent);
    font: 600 40px/1.1 var(--font-heading);
}

.price-for,
.price-note,
.price-saving {
    color: #555;
    font-size: 13px;
    line-height: 1.5;
}

.price-note {
    max-width: 300px;
    margin: 0;
    text-align: right;
}

.price-saving {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    gap: 8px;
    text-align: right;
}

.price-saving strong {
    padding: 7px 14px;
    border-radius: 999px;
    background: var(--accent);
    color: #fff;
}

.consent-card .n-space {
    width: 100%;
}

.captcha-wrap {
    display: inline-block;
    margin-top: 22px;
    padding: 8px;
    border: 1px solid var(--border);
    border-radius: 12px;
    background: #faf9f6;
}

.submit-item {
    margin-top: 28px;
}

.submit-button {
    min-height: 48px;
    border-radius: 12px !important;
    font-weight: 700 !important;
}

.modal-price-summary {
    display: flex;
    align-items: baseline;
    gap: 12px;
    margin-top: 18px;
    padding: 18px 20px;
    border: 1px solid var(--accent-border);
    border-radius: 14px;
    background: var(--accent-tint);
}

.modal-price-summary strong {
    color: var(--accent);
    font: 600 28px var(--font-heading);
}

.modal-price-summary small {
    margin-left: auto;
    color: var(--accent-text);
}

.payment-modal.n-card {
    overflow: hidden;
    border: 1px solid var(--border);
    border-radius: 18px;
    background: var(--surface);
    box-shadow: 0 24px 70px rgba(42, 47, 49, .18);
    font-family: var(--font-body);
}

.payment-modal .n-card-header {
    padding: 25px 30px 21px;
    border-bottom: 1px solid var(--border);
    background: linear-gradient(135deg, var(--accent-tint), #fff 72%);
}

.payment-modal .n-card-header__main {
    color: var(--text);
    font: 600 24px/1.25 var(--font-heading);
}

.payment-modal .n-card__content {
    padding: 28px 30px 30px;
}

.payment-modal-content {
    display: grid;
    gap: 22px;
}

.payment-modal .modal-course-table {
    overflow: hidden;
    border: 1px solid var(--border);
    border-radius: 12px;
    font-size: 13.5px;
}

.payment-modal .modal-course-table th {
    padding: 12px 15px;
    background: var(--soft);
    color: var(--muted);
    font-size: 11.5px;
    font-weight: 700;
    letter-spacing: .04em;
    text-transform: uppercase;
}

.payment-modal .modal-course-table td {
    padding: 13px 15px;
    border-color: #f0ebdc;
    background: var(--surface);
    color: var(--text);
}

.payment-modal .modal-course-table th:first-child,
.payment-modal .modal-course-table td:first-child {
    width: 48px;
    color: var(--muted);
    text-align: center;
}

.payment-modal .modal-course-table th:last-child,
.payment-modal .modal-course-table td:last-child {
    width: 120px;
    text-align: right;
    white-space: nowrap;
}

.payment-modal .modal-course-table th:nth-child(3),
.payment-modal .modal-course-table td:nth-child(3) {
    width: 100px;
}

.modal-mode-badge {
    display: inline-block;
    padding: 4px 10px;
    border-radius: 999px;
    background: var(--soft);
    color: #555;
    font-size: 12px;
    font-weight: 600;
    white-space: nowrap;
}

.payment-modal .modal-price-summary {
    margin-top: 0;
    padding: 22px 24px;
    background: var(--accent-tint);
}

.payment-modal .modal-price-summary > span {
    color: var(--muted);
    font-size: 12px;
    font-weight: 700;
    letter-spacing: .06em;
    text-transform: uppercase;
}

.payment-modal .modal-price-summary small {
    padding: 7px 12px;
    border-radius: 999px;
    background: var(--accent);
    color: #fff;
    font-weight: 600;
}

.modal-bank-card {
    padding: 24px;
    border: 1px solid var(--border);
    border-radius: 14px;
    background: #faf9f6;
}

.modal-section-heading h2 {
    margin: 0 0 7px;
    color: var(--text);
    font: 600 20px/1.3 var(--font-heading);
}

.modal-section-heading p,
.modal-debit-notice {
    margin: 0 0 18px;
    color: var(--muted);
    font-size: 12.5px;
    line-height: 1.6;
}

.modal-debit-notice {
    margin-top: 4px;
    padding-top: 16px;
    border-top: 1px solid var(--border);
}

.modal-debit-consent {
    width: 100%;
}

.modal-error-text {
    margin: -14px 0 0;
    color: var(--error);
    font-size: 12.5px;
}

.modal-actions {
    display: flex;
    justify-content: flex-end;
    gap: 10px;
    padding-top: 20px;
    border-top: 1px solid var(--border);
}

.modal-actions .n-button {
    min-height: 44px;
    padding: 0 20px;
    border-radius: 10px;
    font-weight: 700;
}

.modal-secondary-button {
    border-color: var(--border) !important;
    background: var(--surface) !important;
    color: var(--text) !important;
}

.fade-slide-enter-active, .fade-slide-leave-active {
    transition: all .4s cubic-bezier(.45,0,.55,1);
}
.fade-slide-enter-from, .fade-slide-leave-to {
    opacity: 0;
    transform: translateY(-25px) scale(.98);
}
.fade-slide-enter-to, .fade-slide-leave-from {
    opacity: 1;
    transform: translateY(0) scale(1);
}

@media (max-width: 820px) {
    .application-card {
        padding: 26px 22px;
    }

    .section-heading-row,
    .price-box,
    .modal-price-summary {
        align-items: flex-start;
        flex-direction: column;
    }

    .choice-space {
        grid-template-columns: 1fr;
    }

    .price-note,
    .price-saving {
        align-items: flex-start;
        text-align: left;
    }

    .modal-price-summary small {
        margin-left: 0;
    }

    .payment-modal .n-card-header {
        padding: 21px 20px 18px;
    }

    .payment-modal .n-card__content {
        padding: 20px;
    }

    .payment-modal .modal-course-table th,
    .payment-modal .modal-course-table td {
        padding: 11px 10px;
    }

    .modal-bank-card {
        padding: 19px;
    }

    .modal-actions {
        align-items: stretch;
        flex-direction: column;
    }

    .modal-actions .n-button {
        width: 100%;
    }

}

</style>
